<template>
  <div
    v-if="appliedDiscountsWithCode.length > 0"
    class="flex flex-row flex-wrap items-center px-16 py-4"
  >
    <p class="pe-4">Aktiv rabattkod:</p>

    <button
      v-for="(discountChip, index) in appliedDiscountsWithCode"
      :key="discountChip.couponCode + index"
      class="flex flex-row items-center w-fit bg-label-done rounded-sm px-4 py-2 me-4 body-md"
      :aria-label="`Ta bort rabattkod ${discountChip.couponCode}`"
      @click="() => emit('onRemoveDiscountCode', discountChip.couponCode)"
      @keyup.enter.self.prevent="
        () => $emit('onRemoveDiscountCode', discountChip.couponCode)
      "
      @keyup.space.self.prevent="
        () => emit('onRemoveDiscountCode', discountChip.couponCode)
      "
    >
      {{ discountChip.couponCode }}
      <nuxt-icon
        class="ps-4 [&>*]:text-[14px] text-text-secondary hover:text-text-primary cursor-pointer halebop-focus-rounded"
        name="x"
      />
    </button>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['onRemoveDiscountCode']);
const checkoutStore = useMyCheckoutStore();

type DiscountChipViewModel = {
  couponCode: string;
};

const appliedDiscountsWithCode: DiscountChipViewModel[] =
  checkoutStore.fetchedData.cart?.appliedDiscountsCouponCodes
    ?.filter((discount: any) => !!discount)
    ?.map((discount: any) => ({
      couponCode: discount,
    })) ?? [];
</script>
